module.exports = {
  title: 'card-shader-reflections',
  author: 'Enzo Manuel Mangano',
  date: '2025-02-27',
  slug: 'card-shader-reflections',
  tags: ['skia', 'reanimated'],
};
